export const PRODUCT_IMPORT_MAX_BYTES = 5 * 1024 * 1024;
export const PRODUCT_IMPORT_MAX_ROWS = 1000;
export const PRODUCT_IMPORT_EXTENSIONS = [".xls", ".xlsx"];
export const PRODUCT_IMPORT_MIME_TYPES = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

interface ProductImportFileCandidate {
  name: string;
  type?: string;
  size: number;
}

export const validateProductImportFile = (
  file: ProductImportFileCandidate,
): { valid: true } | { valid: false; message: string } => {
  const fileName = file.name.toLowerCase();
  const isAllowedExtension = PRODUCT_IMPORT_EXTENSIONS.some((extension) =>
    fileName.endsWith(extension),
  );

  if (!isAllowedExtension) {
    return {
      valid: false,
      message: "Only .xls and .xlsx product import files are supported.",
    };
  }

  if (
    file.type &&
    !PRODUCT_IMPORT_MIME_TYPES.includes(file.type) &&
    !file.type.includes("spreadsheet")
  ) {
    return {
      valid: false,
      message: "The selected file type is not a supported spreadsheet.",
    };
  }

  if (file.size > PRODUCT_IMPORT_MAX_BYTES) {
    return {
      valid: false,
      message: "Product import file must be 5 MB or smaller.",
    };
  }

  return { valid: true };
};
